import RestModel from "discourse/models/rest";

export default class TagSettings extends RestModel {}
